import { render, staticRenderFns } from "./BenefitCoreCardTypeSelector.vue?vue&type=template&id=9fd3eb74&scoped=true"
import script from "./BenefitCoreCardTypeSelector.vue?vue&type=script&lang=js"
export * from "./BenefitCoreCardTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./BenefitCoreCardTypeSelector.vue?vue&type=style&index=0&id=9fd3eb74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd3eb74",
  null
  
)

export default component.exports